import useSWR from 'swr';
import { useParams } from 'react-router-dom';
import { SpinnerIconSVG } from 'src/assets/svg';
import container from 'src/container';
import { OrganizationForm } from './components';

const {
    cradle: { munduClient },
} = container;

export const EditOrganization = () => {
    const { id } = useParams<{ id: string }>();
    const { data } = useSWR([`orginfo`, id], (_, orgId) =>
        munduClient.getOrganization(orgId),
    );

    if (!data)
        return (
            <div className="grid justify-center">
                <SpinnerIconSVG className="animate-spin h-8 w-8 text-woodyBrown" />
            </div>
        );

    return <OrganizationForm organization={data} />;
};
